import { LANGUAGES, REGIONS } from 'state/intl/types';

export const regionSupportedLanguages = {
  [REGIONS.US]: new Set([LANGUAGES.en]),
};
